import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialCalendarDate: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.29 9.14h27.42v21.34h1.53V4.57h-1.53V3.05h-4.57V6.1h-1.52V3.05H8.38V6.1H6.86V3.05H2.29v1.52H.76v25.91h1.53zm0 21.34h27.42V32H2.29ZM23.62 0h1.52v3.05h-1.52Z\"/><path fill=\"currentColor\" d=\"M17.52 15.24v6.09h4.57v3.05h-4.57v1.52h6.1v-6.09h-4.57v-3.05h4.57v-1.52zm-4.57 0h-1.52v1.52H8.38v1.53h3.05v6.09H8.38v1.52H16v-1.52h-3.05zM6.86 0h1.52v3.05H6.86Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialCalendarDate
